import axios from 'axios';
import { getItemFromStore } from './utils';

const setAuthToken = (token = null) => {
  if (!token) {
    const user = getItemFromStore('user', false);
    token = user ? user.token : null;
  }

  if (token) {
    axios.defaults.headers.common['auth-token'] = token;
  } else {
    delete axios.defaults.headers.common['auth-token'];
  }
};

export default setAuthToken;
